const formatDate = function (dateStr) {
	const dateObj = new Date(dateStr)
	const day = dateObj.toLocaleString('default', { day: 'numeric' })
	const month = dateObj.toLocaleString('default', { month: 'long' })
	const year = dateObj.toLocaleString('default', { year: 'numeric' })
	return `${day} ${month} ${year}`
}

export default formatDate
